import { Link } from "react-router-dom";

export default function SignupWallModal({ open, used = 5, limit = 5, onClose }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--text)]/70 backdrop-blur-sm px-6"
      data-testid="signup-wall"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm bg-[var(--bg)] border border-[var(--border)] rounded-sm p-8 text-[var(--text)]"
        onClick={(e) => e.stopPropagation()}
      >
        <p
          className="font-mono-ui text-[10px] tracking-[0.3em] uppercase text-[var(--text-muted)] mb-3"
          data-testid="signup-wall-counter"
        >
          {used} / {limit} free queries used
        </p>
        <p className="font-serif italic text-2xl leading-tight mb-3">
          You&apos;ve hit the trial limit.
        </p>
        <p className="font-sans text-sm text-[var(--text-muted)] leading-relaxed mb-7">
          Create an account to keep talking. Your trial conversations stay in this browser; the new account starts clean.
        </p>

        <div className="flex flex-col gap-3">
          <Link
            to="/register"
            data-testid="signup-wall-register"
            className="block text-center py-3 font-mono-ui text-[11px] tracking-[0.3em] uppercase border border-[var(--accent)] text-[var(--accent)] hover:bg-[var(--accent)] hover:text-[var(--bg)] transition-colors"
          >
            Create account
          </Link>
          <Link
            to="/login"
            data-testid="signup-wall-login"
            className="block text-center py-3 font-mono-ui text-[11px] tracking-[0.3em] uppercase border border-[var(--border)] text-[var(--text-muted)] hover:text-[var(--text)] hover:border-[var(--text)] transition-colors"
          >
            Sign in
          </Link>
        </div>

        <p className="font-mono-ui text-[10px] tracking-[0.22em] uppercase text-[var(--text-dim)] text-center mt-6">
          Questions?{" "}
          <a
            href="mailto:support@humanebehavior.com"
            data-testid="signup-wall-support"
            className="hover:text-[var(--accent)] transition-colors"
          >
            support@humanebehavior.com
          </a>
        </p>
      </div>
    </div>
  );
}
